import React from 'react';
import CustomButton from './CustomButton';
import { useNavigate } from 'react-router-dom'
import './MaisClientesSection.css';

const MaisClientesSection = () => {
  const navigate = useNavigate()

  return (
    <section className="mais-clientes-section">
      <div className="mais-clientes-content">
        <div className="mais-clientes-header">
          <h2 className="mais-clientes-title">
            Mais clientes, menos custo de aquisição, receita previsível.
          </h2>
          <p className="mais-clientes-subtitle">
            Atraímos tutores qualificados e entregamos previsibilidade de demanda com tecnologia simples de usar.
          </p>
        </div>

        <div className="mais-clientes-cards">
          <div className="feature-card">
            <div className="card-badge">Sem custo de anúncios</div>
            <h3 className="card-title">Clientes chegam prontos para agendar</h3>
            <p className="card-description">
              Seu custo de aquisição é apenas o valor do repasse que você escolheu. A plataforma faz o marketing por você.
            </p>
          </div>

          <div className="feature-card">
            <div className="card-badge">Mais receita no atendimento</div>
            <h3 className="card-title">Ofereça serviços extras direto no atendimento</h3>
            <p className="card-description">
              Hidratação, corte de unhas — tudo registrado e pago automaticamente.
            </p>
          </div>

          <div className="feature-card">
            <div className="card-badge">Atraia muitos clientes</div>
            <h3 className="card-title">Demanda recorrente no seu petshop</h3>
            <p className="card-description">
              Dias cheios e receita constante. Previsibilidade para planejar seu negócio.
            </p>
          </div>

          <div className="feature-card">
            <div className="card-badge">Plataforma intuitiva</div>
            <h3 className="card-title">Tecnologia simples e fácil de usar</h3>
            <p className="card-description">
              QR Code, relatórios e avaliação integrada. Sem precisar trocar seu sistema atual.
            </p>
          </div>
        </div>

        <div className="mais-clientes-cta">
          <p className="cta-text">Foque no que importa: cuidar bem e faturar mais.</p>
          <CustomButton
            variant="contained"
            sx={{
              backgroundColor: '#FF914D',
              color: '#FFFFFF',
              padding: '14px 32px',
              '&:hover': {
                backgroundColor: '#e67e3d',
              },
            }}
            onClick={() => navigate('/cadastro-parceiro')}
          >
            Quero ser parceiro
          </CustomButton>
        </div>
      </div>
    </section>
  );
};

export default MaisClientesSection;

